import React, { Component } from "react";
import { ErrorNotification, MnemoLoading, ModalHandler, Title } from "components/misc";
import { MSelect } from "components/forms";
import { Button, Row, Col } from "design-react-kit";
import { adminService, lessonSectionService, mySleep, stringHelper } from "libs";

export class LessonLiveScheduleProcessVC extends Component {

  studentsToSkip = [];
  studentsToExport = [];

  state = {
    courseType: "",
    loading: false,
    loadingError: "",
    idExamSession: 0,
    academicYear: 0,
    students: [],
    sections: [],
    studentPayments: [],
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  COURSE_TYPE = {

    34: "CORSI30ALL2",
    35: "CORSI30ALL2",
    57: "CORSI30ALL2",
    50: "CORSI30ALL2",

    41: "CORSI36ALL5",
    59: "CORSI36ALL5",
    52: "CORSI36ALL5",

    30: "ABILITAZIONI60CFU",
    32: "ABILITAZIONI30CFU",
    27: "ABILITAZIONI60CFU",
    29: "ABILITAZIONI30CFU",
    56: "ABILITAZIONI60CFU",
    54: "ABILITAZIONI30CFU",
    49: "ABILITAZIONI60CFU",
    47: "ABILITAZIONI30CFU",
    80: "ABILITAZIONI60CFU",
    82: "ABILITAZIONI30CFU",
  };

  PAYLOAD_EXAMSESSION = {
    2024: {
      options: [
        { label: "SELEZIONA UN CORSO", value: 0 },
        { label: "REGGIO - 60 CFU", value: 80 },
        { label: "REGGIO - 30 CFU", value: 82 },
        { label: "--------------------", value: 0 },
        { label: "UNICAMILLUS - 60 CFU", value: 56 },
        { label: "UNICAMILLUS - 30 CFU", value: 54 },
        { label: "UNICAMILLUS - ALLEGATO2 VINCITORI CONCORSO", value: 57 },
        { label: "UNICAMILLUS - ALLEGATO5 VINCITORI CONCORSO", value: 59 },
        { label: "--------------------", value: 0 },
        { label: "IUL - 60 CFU", value: 49 },
        { label: "IUL - 30 CFU", value: 47 },
        { label: "IUL- ALLEGATO2 VINCITORI CONCORSO", value: 50 },
        { label: "IUL- ALLEGATO5 VINCITORI CONCORSO", value: 52 },

      ],
    },
    2025: {
      options: [
        { label: "SELEZIONA UN CORSO", value: 0 },
        { label: "UNICAMILLUS - 60 CFU", value: 27 },
        { label: "UNICAMILLUS - 30 CFU", value: 29 },
        { label: "UNICAMILLUS - ALLEGATO2 VINCITORI CONCORSO", value: 35 },
        { label: "UNICAMILLUS - ALLEGATO5 VINCITORI CONCORSO", value: 41 },
        { label: "--------------------", value: 0 },
        { label: "REGGIO - 60 CFU", value: 30 },
        { label: "REGGIO - 30 CFU", value: 32 },
        { label: "REGGIO - ALLEGATO2 VINCITORI CONCORSO", value: 34 },
      ],
    },
  };

  setAcademicYear = (_, value) => {
    const idExamSession = 0;
    this.setState({ academicYear: value, idExamSession });
  };

  setIdExamSession = (_, value) => {
    this.setState({ idExamSession: value });
  };

  loadStudents = () => {
    this.setState({ loading: true, loadingError: "", studentPayments: [] });
    const { idExamSession, academicYear } = this.state;

    if (idExamSession === 0) {
      ErrorNotification.render(
        "Devi specificare un edizione per poter procedere"
      );
      this.setState({ loading: false });
    } else {
      const courseType = this.COURSE_TYPE[idExamSession];
      lessonSectionService
        .listAnalyticsStudents(courseType, idExamSession, academicYear)
        .then(({ data }) => {
          const { students, sections } = data.payload;
          this.setState({ students, sections, loading: false, courseType });
        })
        .catch((error) => {
          console.error("Error ", error);
          ErrorNotification.render("Errore  server");
          this.setState({ loading: false, loadingError: error });
        });
    }
  };

  analyzeStudents = (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "" });
    const { students, idExamSession, academicYear } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      if (idExamSession === 0 || academicYear === 0) {
        ErrorNotification.render(
          "Dati inconsistenti. Ricarica l'elenco degli studenti tramite il pulsante 'Elenco studenti'"
        );
        this.setState({ loading: false });
      } else {
        lessonSectionService
          .createAnalyticsStudents(idExamSession, academicYear)
          .then(({ data }) => {
            this.loadStudents();
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error("Error ", error);
            ErrorNotification.render("Errore  server");
            this.setState({ loading: false, loadingError: error });
          });
      }
    }
  };

  analyzeStudent = (student) => {

    this.setState({ studentToAnalyze: student });

    ModalHandler.show(null, 'Ricalcolo statistiche',
      "Stai scegliendo di eliminare le statistiche dello studente " + student.registrationCode + " e ricalcolarle. Questa scelta non sarà revocabile . Confermi? "
      , null, this.analyzeStudentConfirm);

  }

  analyzeStudentConfirm = () => {

    const { studentToAnalyze, academicYear, idExamSession } = this.state;
    this.setState({ loading: true, loadingError: "" });

    lessonSectionService
      .createAnalyticsStudent(studentToAnalyze.registrationCode, idExamSession, academicYear)
      .then(({ data }) => {
        this.setState({ students: data.payload.students, loading: false });
      })
      .catch((error) => {
        console.error("Error ", error);
        ErrorNotification.render("Errore  server");
        this.setState({ loading: false, loadingError: error });
      });
  };

  handleStudentsTableClick = (e) => {
    const action = e.target.closest(".js-analyze-student");
    if (!action) {
      return;
    }

    e.preventDefault();
    const registrationCode = action.getAttribute("data-registration-code");
    if (!registrationCode) {
      return;
    }

    const student = this.state.students.find(
      (s) => s.registrationCode === registrationCode
    );
    if (student) {
      this.analyzeStudent(student);
    }
  };

  verifyPaymentStudents = async (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }
   
    this.setState({ loading: true, loadingError: "", studentPayments: [] });
    const { students } = this.state;
    let studentPayments = [];

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      for (let i = 0; i < students.length; i++) {
        const student = students[i];

        const skip = this.studentsToSkip.find(
          (s) => s === student.registrationCode
        );

        if (!skip) {
          // verify if the registration code already sent
          if (studentPayments[student.registrationCode]) {
            continue;
          }
          studentPayments[student.registrationCode] = "invio in corso";

          await mySleep(400); // to avoid too many request at the same time

          adminService
            .verifyPayment(student.registrationCode)
            .then(({ data }) => {
              if (data.payload.operation) {
                studentPayments[student.registrationCode] =  data.payload.operation;               
                 this.setState({ studentPayments: studentPayments });
              }                
            })
            .catch((error) => {
              console.error("Error ", error);
              console.error(student.registrationCode);
              ErrorNotification.render("Errore server");
                studentPayments[student.registrationCode] =  "Errore server durante verifica pagamento";               
                 this.setState({ studentPayments: studentPayments });
              this.setState({ loading: false, loadingError: error });
            });

        } else {
          studentPayments[student.registrationCode] =
            "Percentuale non raggiunta. Pagamento non generato.";
          this.setState({ studentPayments: studentPayments });
        }
     
      }

      this.setState({ loading: false });
    }
  };

  /** calc percentage */
  calcPercentage = (percentage) => {
    return percentage ? percentage.toString().replace(".", ",") : "0";
  }; //calcPercentage

  exportStudents = () => {
    const { students, sections } = this.state;

    //iterate on sections and prepare string to add to csv header `str`
    let addSectionHeader = "";
    if (sections.length > 0) {
      // Sort sections by code before adding to header
      const sortedSections = [...sections].sort((a, b) =>
        a.code.localeCompare(b.code)
      );
      addSectionHeader = sortedSections
        .map((section) => `;${section.code}`)
        .join("");
    }

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      let str = "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CLASSE CONCORSO;REGIONE;LIMITI RAGGIUNTI" + addSectionHeader;

      if (this.state.courseType === 'ABILITAZIONI60CFU' || this.state.courseType === 'CORSI36ALL5')
        str += ";TIROCINIO_TOTALE\r\n";
      else
        str += "\r\n";

      let sectionCodes = addSectionHeader.split(";").slice(1); // remove the first empty element

      for (let i = 0; i < this.studentsToExport.length; i++) {
        const student = this.studentsToExport[i];
        let limite = "";

        const skip = this.studentsToSkip.find(
          (s) => s === student.registrationCode
        );
        if (skip) {
          limite = "NON RAGGIUNTO";
        }

        let addRow = `${student.registrationCode};${student.surname};${student.name};${student.email};${student.mobile};${student.competitionclass};${student.region};${limite}`;

        // add the relative section value
        let addSectionValues = "";

        sectionCodes.forEach((code) => {

          const studentSection = student[code];
          addSectionValues += `;${studentSection}`;

        });

        if (this.state.courseType === 'ABILITAZIONI60CFU' || this.state.courseType === 'CORSI36ALL5') {
          addSectionValues += `;${student.TOTALE_TIROCINI || "0"}`;
        }
        str += addRow + addSectionValues + "\r\n";
      }

      // calcolo il nome della edizione selezionata
      const selectedEdition = this.PAYLOAD_EXAMSESSION[
        this.state.academicYear
      ].options.find(
        (option) => option.value === parseInt(this.state.idExamSession)
      );
      const editionLabel = selectedEdition ? selectedEdition.label : "";

      let downloadLink = document.createElement("a");
      downloadLink.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(str);
      downloadLink.download =
        "corsisti_esami_" +
        this.state.academicYear +
        "_" +
        editionLabel +
        ".csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  renderStudents() {
    const { students, sections, studentPayments } = this.state;

    let prevStudent = {};
    let currentSections = [...sections];
    let currentSection = {};
    let studentToExport = {};
    let codeSections = "";
    let position = 1;
    this.studentsToSkip = [];
    this.studentsToExport = [];
    let tirocinioTotalMinutes = 0;
    let tirocinioTotal60 = 14400; // 60ALL1 60 ore tirocinio indiretto + 180 ore tirocinio diretto
    if (this.state.courseType === 'CORSI36ALL5') {
      tirocinioTotal60 = 9360; // 36ALL5 36 ore tirocinio indiretto + 120 ore tirocinio diretto
    }

    for (let i = 0; i < students.length; i++) {
      const student = students[i];
      let show = false;

      if (prevStudent?.registrationCode === student.registrationCode) {
        show = false;
        if (!student.section) {
          continue;
        }
      } else {

        // aggiunge le sezioni mancanti nelle frequenze (tabelle *resume)
        if (prevStudent?.registrationCode && currentSections.length > 0) {
          for (let j = 0; j < currentSections.length; j++) {
            const section = currentSections[j];
            codeSections += `<tr key="${j}">
                <td colSpan="8"> </td>
                <td>${section.code}</td>
                <td>
                  0/${section.totalMinutes}
                </td>`;

            studentToExport[section.code] = stringHelper.formatPercentage(0);
            studentToExport[section.code + 'T'] = 0;

            if (section.code === "ATI" || section.code === "ATD") {
              codeSections += `<td> ${stringHelper.formatPercentage(0)}</td>`;

            } else {
              this.studentsToSkip.push(prevStudent.registrationCode);
              codeSections += `<td>
                  ${stringHelper.formatPercentage(0)}
                  <span class="text-red">
                    LIMITE NON RAGGIUNTO
                  </span>
                </td>
              </tr>`;
            }
          }
        }

        // Aggiunge informazioni sul TIROCINIO TOTALE (nel caso 60CFU)
        if (this.state.courseType === 'ABILITAZIONI60CFU' || this.state.courseType === 'CORSI36ALL5') {
          if (prevStudent?.registrationCode) {
            const tirocinioPercent = (tirocinioTotalMinutes * 1.0) / tirocinioTotal60;
            let tirocinioLabel = "";
            if (tirocinioPercent < 0.7) {
              tirocinioLabel = '<span class="text-red">LIMITE NON RAGGIUNTO</span>';
              this.studentsToSkip.push(prevStudent.registrationCode);
            }

            codeSections += `<tr>
                <td colSpan="8"> </td>
                <td>TOTALE TIROCINI</td>
                <td>
                  ${tirocinioTotalMinutes}/${tirocinioTotal60}
                </td>
                <td>
                  ${stringHelper.formatPercentage(tirocinioPercent)}
                  ${tirocinioLabel}
                </td>
              </tr>`;

            studentToExport['TOTALE_TIROCINI'] = stringHelper.formatPercentage(tirocinioPercent);
          }
        }

        if (prevStudent?.registrationCode) {
          studentToExport.registrationCode = prevStudent.registrationCode;
          studentToExport.surname = prevStudent.surname;
          studentToExport.name = prevStudent.name;
          studentToExport.email = prevStudent.email;
          studentToExport.mobile = prevStudent.mobile;
          studentToExport.competitionclass = prevStudent.competitionclass;
          studentToExport.region = prevStudent.region;
          this.studentsToExport.push(studentToExport);
          studentToExport = {};
        }

        prevStudent = student;
        show = true;
        currentSections = [...sections];
        tirocinioTotalMinutes = 0;
        currentSection = {};
      }

      if (student.section && currentSection?.code !== student.section) {
        // find the section by lessoncode  and remove it from currentSections
        currentSection = currentSections.find(
          (s) =>
            s.code.trim().toLowerCase() === student.section.trim().toLowerCase()
        );
        if (currentSection) {
          // remove curentSection from currentSections array
          currentSections = currentSections.filter(
            (s) =>
              s.code.trim().toLowerCase() !==
              currentSection.code.trim().toLowerCase()
          );
        } else {
          console.error("Section not found for student", student);
        }
      }

      const studentPercent =
        (student.minutes * 1.0) / currentSection.totalMinutes;

      codeSections += `<tr key="${i}">`;
      if (show) {
        codeSections += ` <td>${position}`;

        if (
          studentPayments &&
          studentPayments.hasOwnProperty(student.registrationCode)
        ) {
          codeSections += `<br/>${studentPayments[student.registrationCode]}`;
        }


        codeSections += `</td>`;
        codeSections += `
          <td>${student.registrationCode}<br/>
          <a
            href="#"
            class="action icon-link js-analyze-student"
            data-registration-code="${student.registrationCode}"
          >
            Ricalcola Tempo
          </a></td>
          <td>${student.surname}</td>
          <td>${student.name}</td>
          <td>${student.email}</td>
          <td>${student.mobile}</td>
          <td>${student.competitionclass}</td>
           <td>${student.region}</td>`;

        position++;
      } else {
        codeSections += `<td colSpan="8"></td>`;
      }

      let label = "";
      if (studentPercent < 0.7 && !(currentSection.code === "ATI" || currentSection.code === "ATD")) {
        this.studentsToSkip.push(student.registrationCode);
        label = '<span class="text-red">LIMITE NON RAGGIUNTO</span>';
      }

      if (currentSection.code === "ATD" || currentSection.code === "ATI") {
        tirocinioTotalMinutes += parseInt(student.minutes);
      }

      codeSections += `
        <td>${student.section}</td>
        <td>
          ${student.minutes}/${currentSection.totalMinutes}
        </td>
        <td>
          ${stringHelper.formatPercentage(studentPercent)}
          ${label}
        </td>
      </tr>`;

      studentToExport[student.section] = stringHelper.formatPercentage(studentPercent);
      studentToExport[student.section + 'T'] = student.minutes;
    }

    // aggiunge le sezioni mancanti nelle frequenze (tabelle *resume)
    if (prevStudent?.registrationCode && currentSections.length > 0) {
      for (let j = 0; j < currentSections.length; j++) {
        const section = currentSections[j];
        codeSections += `<tr key="${j}">
                <td colSpan="8"> </td>
                <td>${section.code}</td>
                <td>
                  0/${section.totalMinutes}
                </td>`;

        studentToExport[section.code] = stringHelper.formatPercentage(0);
        studentToExport[section.code + 'T'] = 0;

        if (section.code === "ATI" || section.code === "ATD") {
          codeSections += `<td> ${stringHelper.formatPercentage(0)}</td>`;

        } else {
          this.studentsToSkip.push(prevStudent.registrationCode);
          codeSections += `<td>
                  ${stringHelper.formatPercentage(0)}
                  <span class="text-red">
                    LIMITE NON RAGGIUNTO
                  </span>
                </td>
              </tr>`;
        }
      }
    }

    if (this.state.courseType === 'ABILITAZIONI60CFU' || this.state.courseType === 'CORSI36ALL5') {
      if (prevStudent?.registrationCode) {
        const tirocinioPercent = (tirocinioTotalMinutes * 1.0) / tirocinioTotal60;
        let tirocinioLabel = "";
        if (tirocinioPercent < 0.7) {
          tirocinioLabel = '<span class="text-red">LIMITE NON RAGGIUNTO</span>';
          this.studentsToSkip.push(prevStudent.registrationCode);
        }

        codeSections += `<tr>
                <td colSpan="8"> </td>
                <td>TOTALE TIROCINI</td>
                <td>
                  ${tirocinioTotalMinutes}/${tirocinioTotal60}
                </td>
                <td>
                  ${stringHelper.formatPercentage(tirocinioPercent)}
                  ${tirocinioLabel}
                </td>
              </tr>`;

        studentToExport['TOTALE_TIROCINI'] = stringHelper.formatPercentage(tirocinioPercent);
      }
    }

    studentToExport.registrationCode = prevStudent.registrationCode;
    studentToExport.surname = prevStudent.surname;
    studentToExport.name = prevStudent.name;
    studentToExport.email = prevStudent.email;
    studentToExport.mobile = prevStudent.mobile;
    studentToExport.competitionclass = prevStudent.competitionclass;
    studentToExport.region = prevStudent.region;
    this.studentsToExport.push(studentToExport);

    let codeToReturn = `<table class="MTable table table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Codice registrazione</th>
          <th>Cognome</th>
          <th>Nome</th>
          <th>Email</th>
          <th>Telefono</th>
          <th>Classe di concorso</th>
          <th>Regione</th>
          <th>Attività</th>
          <th>Minuti collegamento</th>
          <th>Frequenza di collegamento</th>
        </tr>
      </thead>
      <tbody>${codeSections}</tbody></table>`;
    return codeToReturn;
  }

  render() {
    const { loading, students, academicYear } = this.state;

    return (
      <>
        {loading && <MnemoLoading />}
        <section className="m-4">
          <Title>Analisi frequenza 30/60 CFU e Vincitori di Concorso [Unicamillus - Reggio]</Title>
          <Row>
            <Col md={12}>
              <MSelect
                onChange={this.setAcademicYear}
                id="academicYear"
                payload={this.PAYLOAD_YEAR}
              ></MSelect>
            </Col>
          </Row>
          {academicYear > 0 && (
            <>
              <Row>
                <Col md={6}>
                  <MSelect
                    onChange={this.setIdExamSession}
                    id="idExamSession"
                    payload={this.PAYLOAD_EXAMSESSION[academicYear]}
                  ></MSelect>
                </Col>
              </Row>
            </>
          )}
          <Button
            color="primary bg-dark"
            onClick={() => {
              this.loadStudents();
            }}
          >
            <span className="d-button-label">Elenco studenti</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.analyzeStudents(e);
            }}
          >
            <span className="d-button-label">Calcola tempo presenza</span>
          </Button>
          {
            <Button
              className="ml-2"
              color="primary"
              outline
              onClick={(e) => {
                this.verifyPaymentStudents(e);
              }}
            >
              <span className="d-button-label">
                Verifica pagamenti aggiuntivi
              </span>
            </Button>
          }
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={() => {
              this.exportStudents();
            }}
          >
            <span className="d-button-label">Esporta</span>
          </Button>
          <hr />
          {students.length > 0 && (
            <div
              onClick={this.handleStudentsTableClick}
              dangerouslySetInnerHTML={{ __html: this.renderStudents() }}
            ></div>
          )}
        </section>
      </>
    );
  }
}
